import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginSuccess } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) { navigate("/login"); return; }
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => { loginSuccess(data); navigate("/", { state: { user: data.user } }); })
      .catch((err) => setError(formatApiErrorDetail(err.response?.data?.detail) || "Sign-in failed"));
  }, [navigate, loginSuccess]);

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-4">
      {error ? (
        <div className="text-center space-y-3">
          <p data-testid="auth-callback-error" className="text-rose-400 text-sm">{error}</p>
          <button onClick={() => navigate("/login")} className="text-blue-400 text-sm underline">Back to login</button>
        </div>
      ) : (
        <div className="h-8 w-8 rounded-full border-2 border-blue-500 border-t-transparent animate-spin" />
      )}
    </div>
  );
}
